import { db, storage } from "@/firebaseApp";
import { onSnapshot, doc, setDoc, serverTimestamp } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage"

const profiles = {
    namespaced: true,

    state: {
        all: [],
    },

    getters: {
        id: (state) => (userId) => state.all.find(({ id }) => id == userId),
    },

    mutations: {
        add(state, profile) {
            const index = state.all.findIndex(({ id }) => id == profile.id);
            if (index !== -1) {
                state.all.splice(index, 1, profile);
                return
            }
            state.all.push(profile)
        },
        remove(state, userId) {
            const index = state.all.findIndex(({ id }) => id == userId);
            if (index !== -1) {
                state.all.splice(index, 1);
            }
        },
    },

    actions: {
        get({ commit }, userId) {
            try {
                onSnapshot(doc(db, `profiles/${userId}`), async (doc) => {
                    let data = doc.data()
                    if (data == null) {
                        return
                    }
                    let profile = {
                        ...data,
                        id: doc.id,
                    }
                    if (data.avatar != null) {
                        profile.avatarUrl = await getDownloadURL(ref(storage, data.avatar))
                    }
                    commit("add", profile);
                });
            } catch (error) {
                console.log("ERROR TO GET ALL USERS: " + error);
            }
        },

        async update({ rootState }, { image, name }) {
            const instanceId = rootState.instanceId
            const currentUser = rootState.users.currentUser
            if (instanceId == null) return;
            if (currentUser == null) return;

            try {
                const storageRef = ref(storage, `profiles/${currentUser.uid}/avatar`);
                await uploadBytes(storageRef, image);
                
                await setDoc(doc(db, `profiles/${currentUser.uid}`), {
                    avatar: `profiles/${currentUser.uid}/avatar`,
                    name,
                    updatedAt: serverTimestamp(),
                }, { merge: true })

            } catch (error) {
                console.log('ERROR UPLOADING PROFILE IMAGE', error)
            } 
        },
    },
}

export default profiles

